export const TELEPHONE_NUMBER = "01993\u00A0851130";
export const EMAIL_ADDRESS = "martindrew889@gmail.com";
export const TELEPHONE_NUMBER_HREF = `tel:+441993851130`;
export const EMAIL_ADDRESS_HREF = `mailto:${EMAIL_ADDRESS}`;
export const ROUTE_COOKIES = '/cookies';
export const ROUTE_PRIVACY = '/privacy';
export const ROUTE_MAIN = '/';